<template>
  <div class="lottery">
    <div class="flex flex-col">
      <div class="mt-8 nav-bar">
        <div class="van-nav-bar__left" v-if="!isWechat()">
          <img src="../assets/images/back.svg" alt="" @click="goHomePage">
        </div>
        <van-notice-bar scrollable v-if="luckyDraw.previous && luckyDraw.previous.winner"
                        class="bg-main text-white notice-bar"
                        left-icon="volume-o"
                        :text="$t('lottery_list.notice', {...luckyDraw.previous, ...luckyDraw.previous.winner})"
        />
        <div class="van-nav-bar__right">
          <span class="van-nav-bar__text text-white"
                @click="$router.push('/lottery-history')">{{ $t('lottery_list.title') }}</span>
        </div>
      </div>
    </div>
    <div class="lottery-title" :class="$i18n.locale">
      <div v-if="activeLuckyDraw">
        <img class="w-3 inline-block img-date" src="../assets/images/lottery/date.svg" alt="">
        {{ $t('lottery_list.sn', activeLuckyDraw) }}
        {{ formatDate(activeLuckyDraw.start_date, 'YYYY.MM.DD') }} -
        {{ formatDate(activeLuckyDraw.end_date, 'YYYY.MM.DD') }}
      </div>
    </div>
    <div class="container-swiper">
      <swiper ref="mySwiper" :options="swiperOptions" @slideChange="onSlideChange">
        <swiper-slide v-if="luckyDraw.previous">
          <div class="draw_item draw_previous">
            <h3 class="text-xl">
              <div class="text-sm">{{ $t('lottery_list.prize_previous') }}</div>
              <div class="text-hidden">{{ $t('lottery_list.prize', luckyDraw.previous) }}</div>
            </h3>
<!--            <p class="my-1 text-sm text-main">{{ $t('lottery_list.date', { date: formatDate(luckyDraw.previous.end_date, 'MM.DD') }) }}</p>-->
            <img v-if="luckyDraw.previous.logo" class="img-logo text-center inline-block"
                 :src="luckyDraw.previous.logo" alt="">
            <van-button disabled type="info" class="btn-draw-previous my-4 w-10/12 rounded-lg text-white">
              <span v-if="luckyDraw.previous.winner">{{ $t('lottery_list.action_previous') }}</span>
              <span v-else>{{ $t('lottery_list.action_previous_waiting') }}</span>
            </van-button>
          </div>
        </swiper-slide>
        <swiper-slide v-if="luckyDraw.current">
          <div class="draw_item draw_current">
            <h3 class="text-xl">
              <div class="text-sm">{{ $t('lottery_list.prize_current') }}</div>
              <div class="text-hidden">{{ $t('lottery_list.prize', luckyDraw.current) }}</div>
            </h3>
<!--            <p class="my-1 text-sm text-main">{{ $t('lottery_list.date', { date: formatDate(luckyDraw.current.end_date, 'MM.DD') }) }}</p>-->
            <img v-if="luckyDraw.current.logo" class="img-logo text-center inline-block" style=""
                 :src="luckyDraw.current.logo" alt="">
            <van-button v-if="luckyDraw.current.joined" disabled type="info" class="btn-draw-previous my-4 w-10/12 rounded-lg text-white">
              {{ $t('lottery_list.status.ready') }}
            </van-button>
            <van-button v-else type="warning" class="my-4 w-10/12 bg-main rounded-lg text-base" :loading="loading" @click="onLuckyDraw">
              {{ $t('lottery_list.action_current', luckyDraw.current) }}
            </van-button>
          </div>
        </swiper-slide>
        <swiper-slide :class="{'coming': !luckyDraw.next}">
          <div v-if="luckyDraw.next" class="draw_item draw_next">
            <h3 class="text-xl">
              <div class="text-sm">{{ $t('lottery_list.prize_next') }}</div>
              <div class="text-hidden">{{ $t('lottery_list.prize', luckyDraw.next) }}</div>
            </h3>
<!--            <p class="my-1 text-sm text-main">{{ $t('lottery_list.date', { date: formatDate(luckyDraw.next.end_date, 'MM.DD') }) }}</p>-->
            <img v-if="luckyDraw.next.logo" class="img-logo text-center inline-block"
                 :src="luckyDraw.next.logo" alt="">
            <van-button disabled type="info" class="btn-draw-previous my-4 w-10/12 rounded-lg text-white">
              {{ $t('lottery_list.action_next') }}
            </van-button>
          </div>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
    <div class="text-center">
      <p class="mt-3 text-sm text-white-750">{{ $t('lottery_list.swipe_prompt') }}</p>
      <img class="lottery-logo" src="../assets/images/lottery/logo_line.png" alt="">
    </div>
    <p class="text-sm text-white-750 text-center pt-2 pb-4" @click="dialogRuleInfo = true">{{ $t('lottery_list.rule') }}</p>

    <!-- 抽奖详情 -->
    <lottery-detail-dialog ref="lotteryDetailDialog"></lottery-detail-dialog>

    <!-- 抽奖规则 -->
    <BudDialog :showDialog="dialogRuleInfo" @close-dialog="dialogRuleInfo = false">
      <div class="pd-20">
        <h3 class="text-center">{{ $t('lottery_rules.title') }}</h3>
        <ol class="p-3">
          <li class="text-sm text-white-750 my-2" v-for="(item, index) in $t('lottery_rules.list')" :key="index">
            {{ item }}
          </li>
          <li class="text-sm text-white-750 my-2" v-if="isIos()">{{ $t('lottery_rules.apple') }}</li>
        </ol>
      </div>
    </BudDialog>
  </div>
</template>

<script>
import BudDialog from '../components/BudDialog'
import LotteryDetailDialog from '../components/LotteryDetailDialog'
import {isWechat, isIos} from '@/helpers/utils'
import _ from 'lodash'

export default {
  components: {
    BudDialog,
    LotteryDetailDialog
  },
  data() {
    return {
      swiperOptions: {
        slidesPerView: 'auto',
        spaceBetween: 0,
        centeredSlides: true,
        initialSlide: 1,
        pagination: {
          el: '.swiper-pagination',
        },
        observer: true
      },
      slideActiveIndex: 1,
      slideKeys: [],
      luckyDraw: {},
      dialogRuleInfo: false,
      loading: false
    };
  },
  computed: {
    activeLuckyDraw() {
      return _.get(this.luckyDraw, this.slideKeys[this.slideActiveIndex], {})
    }
  },
  created() {
    this.luckyDraw = JSON.parse(localStorage.getItem('luckDraw') || '{}');
    console.log('luckyDraw', this.luckyDraw);
    this.initSlideOptions();
  },
  methods: {
    isWechat,
    isIos,
    initSlideOptions() {
      this.slideKeys = ['next'];
      if (this.luckyDraw.current) {
        this.slideKeys.unshift('current');
      }
      if (this.luckyDraw.previous) {
        this.slideKeys.unshift('previous');
      }
      if (this.slideKeys.length < 3) {
        this.swiperOptions.initialSlide = 0;
        this.slideActiveIndex = 0;
      }
    },
    onSlideChange() {
      this.slideActiveIndex = this.$refs.mySwiper.swiper.activeIndex
    },
    goHomePage() {
      this.$router.push('/');
    },
    onLuckyDraw() {
      this.loading = true;
      this.$http.post('game/lucky_draw/pay')
        .then(res => {
          this.loading = false;
          this.$refs.lotteryDetailDialog.show({
            action: 'draw',
            ...res.data,
            lucky_draw: this.luckyDraw.current
          });
          _.set(this.luckyDraw, 'current.joined', true);
          localStorage.setItem('luckDraw', JSON.stringify(this.luckyDraw))
        }).catch(() => {
          this.loading = false;
        })
    }
  },
}
</script>

<style lang="scss">
.lottery {
  background-image: url("../assets/images/lottery/bg.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: fixed;
  min-height: 100%;

  .notice-bar {
    width: 200px;
    height: 24px;
    line-height: 24px;
    font-size: 0.75rem;
    margin: 0 auto;
    border-radius: 20px;
    border: 2px solid #FEF01C;
  }

  .lottery-title {
    background-repeat: no-repeat;
    background-position: center 15px;
    background-size: 274px 99px;
    height: 130px;
    font-size: 0.75rem;
    color: #fff;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    &.cn {
      background-image: url("../assets/images/lottery/lottery_draw_cn.png");
    }
    &.en {
      background-image: url("../assets/images/lottery/lottery_draw_en.png");
    }
  }

  .nav-bar {
    position: relative;
    z-index: 1;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    align-items: center;
    line-height: 1.5;
    text-align: center;
    -webkit-user-select: none;
    user-select: none;
  }

  .btn-draw-previous {
    opacity: 1;
    border: none;
    background-color: #9E9E9E;
    color: #fff;
  }

  .container-swiper {
    .swiper-wrapper {
      height: 420px;
    }

    .swiper-slide {
      background: url("../assets/images/lottery/box.png") no-repeat;
      background-size: contain;
      background-position-x: 50%;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      transition: 300ms;
      transform: scale(0.8);
      width: 311px;
      height: 401px;
      margin: 0 -15px;

      &.swiper-slide-active, &.swiper-slide-duplicate-active{
        transform: scale(1);
      }

      .draw_item {
        color: #fff;
        width: 60%;
        text-align: center;
        .img-logo {
          width: 180px;
          height: 180px;
        }
      }

      &.coming::after {
        content: '';
        display: block;
        width: 100%;
        height: 100%;
        position: absolute;
        background: url("../assets/images/lottery/coming.png") no-repeat center;
      }
    }

    .swiper-pagination {
      overflow: visible;
      bottom: 0;

      .swiper-pagination-bullet {
        width: 12px;
        height: 4px;
        border-radius: initial;
        opacity: 1;
        background-color: #fff;

        &.swiper-pagination-bullet-active {
          background-color: theme('colors.main');
          width: 20px;
        }
      }
    }
  }

  .lottery-logo {
    display: inline-block;
    width: 92px;
    height: 24px;
    margin-top: 4rem;
  }

  ol {
    list-style: decimal inside;
  }
}

</style>
